var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70643 2.83092C7.8879 2.7253 8.11178 2.7253 8.29325 2.83092L7.70643 2.83092ZM7.70643 2.83092L3.70648 5.15889C3.70647 5.1589 3.7065 5.15888 3.70648 5.15889C3.52691 5.26344 3.4165 5.45546 3.4165 5.66271V10.3374C3.4165 10.5444 3.5267 10.7368 3.70703 10.8422C3.70694 10.8421 3.70711 10.8422 3.70703 10.8422L7.70643 13.1698C7.8879 13.2754 8.11178 13.2754 8.29325 13.1698L12.2932 10.8419C12.2932 10.8419 12.2932 10.8419 12.2932 10.8419C12.4728 10.7373 12.5832 10.5453 12.5832 10.338V5.66271C12.5832 5.45546 12.4728 5.26347 12.2932 5.15892C12.2932 5.15891 12.2933 5.15893 12.2932 5.15892L8.29325 2.83092M9.04776 1.5345L13.0478 3.8625C13.6882 4.23528 14.0832 4.92065 14.0832 5.66271V10.338C14.0832 11.0801 13.6882 11.7654 13.0478 12.1382L9.04776 14.4663C8.3999 14.8433 7.59978 14.8433 6.95192 14.4663L2.95191 12.1383C2.31238 11.7649 1.9165 11.0796 1.9165 10.3374V5.66271C1.9165 4.92065 2.31146 4.23531 2.95186 3.86253L6.95191 1.5345C7.59977 1.15745 8.3999 1.15745 9.04776 1.5345Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.25C8.41421 7.25 8.75 7.58579 8.75 8V14C8.75 14.4142 8.41421 14.75 8 14.75C7.58579 14.75 7.25 14.4142 7.25 14V8C7.25 7.58579 7.58579 7.25 8 7.25Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.816 4.64543C14.0229 5.00423 13.8998 5.46287 13.541 5.66983L8.37436 8.64983C8.01555 8.85678 7.55691 8.73367 7.34996 8.37486C7.143 8.01606 7.26611 7.55742 7.62492 7.35046L12.7916 4.37046C13.1504 4.16351 13.609 4.28662 13.816 4.64543Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18345 4.64543C2.3904 4.28662 2.84904 4.16351 3.20785 4.37046L8.37452 7.35046C8.73333 7.55742 8.85643 8.01606 8.64948 8.37486C8.44253 8.73367 7.98389 8.85678 7.62508 8.64983L2.45841 5.66983C2.09961 5.46287 1.9765 5.00423 2.18345 4.64543Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCube);
export default __webpack_public_path__ + "static/media/icon-cube.472d8b72376935c96534bab964f17238.svg";
export { ForwardRef as ReactComponent };